import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    dialogVisible;
    gridData;
    handleClose() {
        this.$emit('update:dialogVisible', false);
    }
};
__decorate([
    Prop()
], default_1.prototype, "dialogVisible", void 0);
__decorate([
    Prop()
], default_1.prototype, "gridData", void 0);
default_1 = __decorate([
    Component({
        name: 'model',
        components: {},
        i18n: {
            messages: {
                en: {
                    title: 'Abnormal information ({msg})',
                    deviceName: 'Device',
                    zoneName: 'Area',
                    errorMsg: 'Reason',
                },
                zh: {
                    title: '异常信息 ({msg})',
                    deviceName: '设备名称',
                    zoneName: '所属区域',
                    errorMsg: '错误信息',
                },
            },
        },
    })
], default_1);
export default default_1;
